export const firebaseConfig = {
  apiKey: "AIzaSyDKsWPvMFA01VNMlKHjR7K7rUcUjClinSM",
  authDomain: "dmj-online.firebaseapp.com",
  projectId: "dmj-online",
  storageBucket: "dmj-online.appspot.com",
  messagingSenderId: "1028550654104",
  appId: "1:1028550654104:web:1906004dd229e340a238ed",
};
